import { createStore } from 'redux'
import rootReducer from './reducer'

import { configureStore } from '@reduxjs/toolkit';

import customReducer from './action/session.js';

const store = createStore(rootReducer)

const customStore = configureStore({reducer: customReducer});

export default store
export { customStore }